import type { AttributeType } from 'cadenza/repository/attribute-type';
import { NUMERIC_TYPES } from 'cadenza/repository/attribute-type';
import type { WorkbookAttributeDto } from 'cadenza/workbook/api/workbook-attribute-dto';
import type { AttributeBundleDefinitionDto } from 'cadenza/workbook/model/attribute-bundle-definition-dto';

const ANALYSIS_CONTEXT_ACCEPTED_TYPES: AttributeType[] = ['STRING', 'IPADDRESS', 'DATE', 'LOB', ...NUMERIC_TYPES];
export const ANALYSIS_CONTEXT_ATTRIBUTE_BUNDLE_DEFINITION: Pick<
  AttributeBundleDefinitionDto,
  'acceptedAttributeCategories' | 'acceptedAttributeTypes'
> = {
  acceptedAttributeCategories: ['MEASURE', 'DIMENSION'],
  acceptedAttributeTypes: {
    MEASURE: ANALYSIS_CONTEXT_ACCEPTED_TYPES,
    DIMENSION: ANALYSIS_CONTEXT_ACCEPTED_TYPES,
  },
};

export function analysisContextAccepts(attribute: WorkbookAttributeDto) {
  const acceptedTypes = ANALYSIS_CONTEXT_ATTRIBUTE_BUNDLE_DEFINITION.acceptedAttributeTypes[attribute.category];
  return (
    ANALYSIS_CONTEXT_ATTRIBUTE_BUNDLE_DEFINITION.acceptedAttributeCategories.includes(attribute.category) &&
    (acceptedTypes == null || !acceptedTypes?.length || acceptedTypes.includes(attribute.type))
  ); // acceptedTypes empty means we accept all
}
